import React from 'react';
import {FormattedMessage} from 'react-intl';
import useActiveLinkClass from '../../../_common/components/_custom-hooks/useActiveLinkClass';
import {pathnames as P} from '../../../_common/constants/pathnames';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const PriceQuoteDetailsLink = () => {
  const {activeClassName} = useActiveLinkClass({url: P.PRICE_QUOTE_DETAILS, hasSubmenu: false});

  return activeClassName && (
    <AsideMenuLink
      pathname={P.PRICE_QUOTE_DETAILS}
      isSubSection={true}
      icon={'Folder_green.svg'}
      label={<FormattedMessage id="price-quote-details-page-link" defaultMessage="Price quote details"/>}
    />
  );
};

export default PriceQuoteDetailsLink;
